<div class="city-bg" style="background-image: url(/images/city.svg);"></div>
<div class="login-container drop-shadow bottom">
  <h1 class="login--header">Password Reset</h1>
  <p>Your password has been reset. Please proceed to login.</p>
  <div class="btn-group center margin">
    <button class="std-btn focus-element" [routerLink]="['/auth/login']"><span class="focus--content" tabindex="-1">Login Now</span></button>
  </div>
</div>
